import React from 'react';
import './NoAccess.css';

interface NoAccessProps {
  name?: string;
  email?: string;
  onLogout: () => void;
}

const NoAccess: React.FC<NoAccessProps> = ({ name, email, onLogout }) => (
  <div className="no-access">
    <div className="no-access-card">
      <div className="no-access-icon" aria-hidden="true">
        🔒
      </div>
      <h1>Je hebt geen toegang tot het beheer</h1>
      <p>
        Je bent ingelogd{name ? ` als ${name}` : ''}
        {email ? ` (${email})` : ''}, maar je account is uitgezet voor de duofietsapplicatie.
      </p>
      <p className="no-access-help">
        Neem contact op met de beheerder van de duofietsapplicatie als dit niet klopt. Zodra je
        account weer aanstaat, kun je hier gewoon opnieuw inloggen.
      </p>
      <div className="no-access-actions">
        <a className="btn btn-secondary" href="/">
          Terug naar de startpagina
        </a>
        <button className="btn btn-primary" onClick={onLogout}>
          Uitloggen
        </button>
      </div>
    </div>
  </div>
);

export default NoAccess;
